import { useState } from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-taleva-indigo text-white p-4 shadow-md fixed top-0 left-0 right-0 z-50">

      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-2xl font-bold">Hôtel Taleva</h1>

        {/* Menu desktop */}
        <ul className="hidden md:flex space-x-6">
          <li><a href="#accueil" className="hover:text-taleva-red">Accueil</a></li>
          <li><a href="#about" className="hover:text-taleva-red">À propos</a></li>
          <li><a href="#services" className="hover:text-taleva-red">Services</a></li>
          <li><a href="#contact" className="hover:text-taleva-red">Contact</a></li>
        </ul>

        {/* Bouton hamburger mobile */}
        <button 
          className="md:hidden focus:outline-none" 
          onClick={() => setIsOpen(!isOpen)} 
          aria-label="Toggle menu"
        >
          <svg 
            className="w-6 h-6" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            {isOpen ? (
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            ) : (
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 6h16M4 12h16M4 18h16" 
              />
            )}
          </svg>
        </button>
      </div>

      {/* Menu mobile */}
      {isOpen && (
        <ul className="md:hidden mt-4 space-y-3 text-left pl-4">
         <li><a href="#accueil" className="block hover:text-taleva-red" onClick={() => setIsOpen(false)}>Accueil</a></li>
          <li><a href="#about" className="block hover:text-taleva-red" onClick={() => setIsOpen(false)}>À propos</a></li>
          <li><a href="#services" className="block hover:text-taleva-red" onClick={() => setIsOpen(false)}>Services</a></li>
          <li><a href="#contact" className="block hover:text-taleva-red" onClick={() => setIsOpen(false)}>Contact</a></li>
        </ul>
      )}
    </nav>
  );
}
